// @flow
import * as React from 'react';
import { Query } from '@apollo/client/react/components';

import { FEATURE_FLAG_IS_ENABLED } from '../../queries';

type FeatureFlagContainerProps = {
  children: any => React.Node,
  clientId: string,
  feature: string,
};

const FeatureFlagContainer = ({ children, clientId, feature }: FeatureFlagContainerProps) => (
  <Query query={FEATURE_FLAG_IS_ENABLED} variables={{ clientId, feature }}>
    {({ data, loading, error }: any) => {
      if (loading || error) {
        return children(null);
      }

      return children(data.featureEnabled);
    }}
  </Query>
);

export default FeatureFlagContainer;
